import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


export type SubscriptionStatus =
  | 'ACTIVE'
  | 'REMINDER'
  | 'EXPIRED'
  | 'USER_LIMIT_EXCEEDED';

export interface SubscriptionState {
  status: SubscriptionStatus;
  value: number;
  code: string;
}

@Injectable({
  providedIn: 'root'
})
export class SubscriptionServiceService {

  constructor() { }

  private subscriptionSubject = new BehaviorSubject<SubscriptionState | null>(null);

  subscription$ = this.subscriptionSubject.asObservable();


  setSubscription(code: string): void {

    if (!code) {
      return;
    }

    const type = code.charAt(0).toUpperCase();
    const value = Number(code.substring(1)) || 0;

    let status: SubscriptionStatus;

    switch (type) {

      case 'B':
        status = 'ACTIVE';
        break;

      case 'R':
        status = 'REMINDER';
        break;

      case 'E':
        status = 'EXPIRED';
        break;

      case 'U':
        status = 'USER_LIMIT_EXCEEDED';
        break;

      default:
        console.warn(
          'Unknown subscription status:',
          code
        );
        return;
    }

    this.subscriptionSubject.next({
      status,
      value,
      code
    });
  }

  getCurrentState(): SubscriptionState | null {
    return this.subscriptionSubject.value;
  }

  isExpired(): boolean {
    return this.subscriptionSubject.value?.status === 'EXPIRED';
  }

  isUserLimitExceeded(): boolean {
    return this.subscriptionSubject.value?.status === 'USER_LIMIT_EXCEEDED';
  }

  isBlocked(): boolean {
    const status =
      this.subscriptionSubject.value?.status;

    return status === 'EXPIRED' ||
      status === 'USER_LIMIT_EXCEEDED';
  }
}